/**
 * Follow-up Question Processor
 * 
 * Handles extraction and formatting of follow-up questions from markdown content
 * Based on the legacy implementation patterns from Answer component
 */

import type { FollowUpQuestion } from '../types';

export const FOLLOWUP_CONSTANTS = {
  REGEX: /<<([^>>]+)>>/g,
  PREFIX: '__FOLLOWUP__',
  SUFFIX: '__FOLLOWUP__',
} as const;

export function processFollowUpQuestions(content: string): {
  content: string;
  questions: FollowUpQuestion[];
} {
  const questions: FollowUpQuestion[] = [];
  
  const processedContent = content.replace(
    FOLLOWUP_CONSTANTS.REGEX,
    (match, questionText) => {
      const question: FollowUpQuestion = {
        id: `followup-${questions.length + 1}`,
        text: questionText.trim(),
        index: questions.length + 1,
      };
      
      questions.push(question);
      
      // Convert to blockquote format for react-markdown
      return `\n\n> ${FOLLOWUP_CONSTANTS.PREFIX}${question.text}${FOLLOWUP_CONSTANTS.SUFFIX}\n\n`;
    }
  );

  return { content: processedContent, questions };
}